import { createContext, useContext, useState, useEffect } from "react";
import React from "react";

const ThemeCtx = createContext({ theme: "light", setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("theme") || "light");
  const setTheme = (t) => { localStorage.setItem("theme", t); setThemeState(t); };
  useEffect(() => {
    const cls = document.documentElement.classList;
    if (theme === "dark") cls.add("dark"); else cls.remove("dark");
  }, [theme]);
  return <ThemeCtx.Provider value={{ theme, setTheme }}>{children}</ThemeCtx.Provider>;
}

export function useTheme() { return useContext(ThemeCtx); }
